import React, { useEffect, useState } from "react";
import api from '../../../config/axiosConfig';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

const Orders = () => {
    const [bookings, setBookings] = useState([]);
    const [filteredBookings, setFilteredBookings] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [formData, setFormData] = useState({
        accountid: '',
        bookingid: '',
        categoryid: '',
        subCategoryid: '',
        itemid: '',

    })
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);
    const [orderItems, setOrderItems] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);

    const getData = async () => {

        const bookingResponse = await api.get("/bookings/activebookings");
        setBookings(bookingResponse.data);

        const accountResponse = await api.get("/accounts");
        setAccounts(accountResponse.data);

        const categoriesResponse = await api.get("/itemtypes");
        setCategories(categoriesResponse.data);

        const subCtaegoriesResponse = await api.get("/categories");
        setSubCategories(subCtaegoriesResponse.data);

        const itemsResponse = await api.get("/items");
        setItems(itemsResponse.data);
    }

    useEffect(() => {
        getData()
    }, []);

    useEffect(() => {
        // Recalculate the total price whenever orderItems changes
        const total = orderItems.reduce((acc, item) => acc + item.perpersonrateINR * item.quantity, 0);
        setTotalPrice(total);
    }, [orderItems]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));

    };

    const handleItemTypeChange = (e) => {
        const selectedItemTypeId = Number(e.target.value);
        setFormData({ ...formData, categoryid: selectedItemTypeId });

        const filtered = subCategories.filter(subCategory => subCategory.itemTypeId == selectedItemTypeId);
        setFilteredCategories(filtered);
    };

    const handleSubCategoryChange = (e) => {
        const selectedubCategoryId = Number(e.target.value);
        setFormData({ ...formData, subCategoryid: selectedubCategoryId });

        const filtered = items.filter(item => item.categoryid == selectedubCategoryId);
        setFilteredSubCategories(filtered);
    };

    const handleAddItem = (item) => {
        setOrderItems((prevItems) => {
            const existingItem = prevItems.find((orderItem) => orderItem.id === item.id);
            if (existingItem) {
                return prevItems.map((orderItem) =>
                    orderItem.id === item.id ? { ...orderItem, quantity: orderItem.quantity + 1 } : orderItem
                );
            }
            return [...prevItems, { ...item, quantity: 1 }];
        });
    };

    const handleQuantityChange = (itemId, quantity) => {
        setOrderItems((prevItems) =>
            prevItems.map((item) =>
                item.id === itemId ? { ...item, quantity: Number(quantity) } : item
            )
        );
    };

    const handleCancelItem = (itemId) => {
        setOrderItems((prevItems) =>
            prevItems.filter((item) => item.id !== itemId)
        );
    };

    const handleAddData = async () => {
          try {
            const url = isEditMode ? `/orders/${formData.id}` : '/orders';
            const method = isEditMode ? 'put' : 'post';
            
            await api({
              method,
              url,
              data:{
                bookingId: formData.bookingid,
                orderItems: orderItems,
              }
            })
    
           
          } catch (error) {
            console.error('Error:', error);
          }
    
          setIsEditMode(false);
      };

      const handleNotesChange = (itemId, notes) => {
        setOrderItems((prevItems) =>
            prevItems.map((item) =>
                item.id === itemId ? { ...item, notes } : item
            )
        );
    };

    const handleAccountChange = (e) => {
        const selectedAccountId = Number(e.target.value);
        setFormData({ ...formData, accountid: selectedAccountId });

        const filtered = bookings.filter(booking => booking.accountId == selectedAccountId);
        setFilteredBookings(filtered);
    };

    return (
        <Container fluid>
            <Row className="mt-4 border shadow p-4">
                <Form >
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Account</Form.Label>
                                <InputGroup>
                                    <Form.Select
                                        name="accountid"
                                        value={formData.accountid}  // This will hold the selected item type ID
                                        onChange={handleAccountChange} // Handle item type change
                                    >
                                        <option value="">Select Account</option>
                                        {accounts && accounts.map((account) => (
                                            <option key={account.id} value={account.id}>
                                                {account.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Booking</Form.Label>
                                <InputGroup>
                                    <Form.Select
                                        name="bookingid"
                                        value={formData.bookingid}  // This will hold the selected item type ID
                                        onChange={handleChange} // Handle item type change
                                    >
                                        <option value="">Select Booking</option>
                                        {filteredBookings && filteredBookings.map((booking) => (
                                            <option key={booking.id} value={booking.id}>
                                                {booking.referenceCode} - {booking.id}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Categories</Form.Label>
                                <InputGroup>
                                    <Form.Select
                                        name="categoryid"
                                        value={formData.categoryid}  // This will hold the selected item type ID
                                        onChange={handleItemTypeChange} // Handle item type change
                                    >
                                        <option value="">Select Category</option>
                                        {categories && categories.map((category) => (
                                            <option key={category.id} value={category.id}>
                                                {category.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Sub Categories</Form.Label>
                                <InputGroup>
                                    <Form.Select
                                        name="subCategoryid"
                                        value={formData.subCategoryid}  // This will hold the selected item type ID
                                        onChange={handleSubCategoryChange} // Handle item type change
                                    >
                                        <option value="">Select Sub Category</option>
                                        {filteredCategories && filteredCategories.map((subCategory) => (
                                            <option key={subCategory.id} value={subCategory.id}>
                                                {subCategory.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Items</Form.Label>
                                <InputGroup>
                                    <Form.Select
                                        name="itemid"
                                        onChange={(e) => handleAddItem(filteredSubCategories.find((item) => item.id == e.target.value))}
                                    >
                                        <option value="">Select Items</option>
                                        {filteredSubCategories.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name} - ₹{item.perpersonrateINR}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Row>
            {/* Order Items Table */}
            <Row className="mt-4">
                <Table bordered>
                    <thead>
                        <tr>
                            <th>Item Name</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Notes</th>
                            <th>Total</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderItems.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    {item.name}
                                    {item.note && <div style={{ marginTop: "4px", color: "#555" }}> Note : {item.note}</div>}
                                </td>

                                <td>₹{item.perpersonrateINR}</td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        value={item.quantity}
                                        onChange={(e) => handleQuantityChange(item.id, e.target.value)}
                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        value={item.notes}
                                        onChange={(e) => handleNotesChange(item.id, e.target.value)}
                                    />
                                </td>
                                <td>₹{(item.perpersonrateINR * item.quantity).toFixed(2)}</td>
                                <td>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => handleCancelItem(item.id)}
                                    >
                                        Cancel
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Row>

            {/* Total Price */}
            <Row>
                <Col className="d-flex justify-content-end align-items-center p-2">
                    <Button
                        variant="primary"
                        size="m"
                        onClick={() => handleAddData()}
                        className="me-2 mb-1"
                    >
                        Place Order
                    </Button>
                    <h4 className="me-4">Total: ₹{totalPrice.toFixed(2)}</h4>
                </Col>

            </Row>
        </Container>
    )
}

export default Orders;